import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function OnboardingBodyAutomations() {
    return (
        <OnboardingBody title='Below each stage…'>
            <div>
                <p>
                    Define <strong>goals</strong> for your team to work toward, create{' '}
                    <strong>automated tasks</strong> to ensure follow-through.
                </p>
                <p>
                    Automatically send <strong>Nutshell drip sequence emails</strong> to your leads
                    at the appropriate stage.
                </p>
            </div>
        </OnboardingBody>
    );
}
